<template>
  <pagina-erro
    titulo="Informação importante"
    icone="fa fa-calendar-times-o"
    imagemTexto="centralservidor-logo-texto.png"
    imagem="centralservidor-logo.png"
    texto="Sua secretaria não participará,
      neste ano, do cadastramento através da Central do Servidor. Informe-se
      com seu superior direto."
    >
  </pagina-erro>
</template>

<script >
import PaginaErro from '@/components/pagina-erro'

export default {
  name: 'UorNaoParticipante',
 	components: {
		PaginaErro
	}
}
</script>



// WEBPACK FOOTER //
// index.vue?ca5b6260